<template>
  <div class="create-price">
    <Header />
    <Main>
      <h3 class="text-center">
        Создание абонемента в спортзале "{{ gymName.toUpperCase() }}"
      </h3>
      <b-overlay :show="loading">
        <price-form v-model="priceData" class="create-price__form" />
      </b-overlay>
    </Main>
    <bottom-overlay v-if="edited">
      <b-button
        @click="createPrice"
        block
        squared
        variant="success"
        class="create-price__create-button"
        :disabled="loading"
      >
        Создать абонемент
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Main from "@/components/Layout/Main";
import PriceForm from "@/components/Forms/Gym/Price/PriceForm";
import PriceModel from "@/components/Forms/Gym/models/priceModel";
import axios from "@/axios";
import BottomOverlay from "@/components/BottomOverlay";
import { mapActions, mapGetters } from "vuex";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: { BottomOverlay, PriceForm, Main },
  mixins: [pageTitleMixin],
  props: {
    gymId: {
      type: Number,
      required: true
    }
  },
  data() {
    let priceData = new PriceModel();
    priceData.gym_id = this.gymId;
    return {
      priceData,
      loading: false
    };
  },
  computed: {
    ...mapGetters("gyms", ["gyms"]),
    edited: ({ priceData, gymId }) => {
      let empty = new PriceModel();
      empty.gym_id = gymId;
      return JSON.stringify(priceData) !== JSON.stringify(empty);
    },
    gym: ({ gyms, gymId }) => gyms.find(({ id }) => Number(id) === gymId),
    gymName: ({ gym }) => gym?.name || ""
  },
  methods: {
    ...mapActions("gyms", ["loadGyms"]),
    createPrice() {
      this.loading = true;
      axios
        .post(`/gyms/prices`, this.priceData)
        .then(res => {
          this.$router.push(
            `/gyms/${this.gymId}/prices/${res.data.gym_price.id}`
          );
          this.loadGyms();
        })
        .catch(() => (this.loading = false));
    }
  }
};
</script>

<style lang="scss">
.create-price {
  &__form {
    padding: 5px;
  }
  &__create-button {
    height: 50px;
  }
}
</style>
